// extracted by mini-css-extract-plugin
export default {"container":"LayoutPicker__container___qCt9F","heading":"LayoutPicker__heading___G5x7V","items":"LayoutPicker__items___J2ZUp","item":"LayoutPicker__item___ybJSm"};